export const battleMessages = {
  playerMiss: [
    "Rate ! Le formulaire est tombe derriere le bureau.",
    "Votre appel n'a pas abouti. Veuillez reessayer.",
    "Le courrier s'est perdu a La Poste. Classique.",
    "Erreur de saisie ! Le Cerfa est invalide.",
    "Le fax n'est jamais arrive. Comme d'habitude."
  ],
  playerHit: [
    "Touche ! L'administration tremble !",
    "Coup direct ! Le tampon a marque !",
    "Bien joue ! Le dossier est accepte !",
    "Impact ! Le guichetier recule d'un pas !",
    "Ca passe ! Le formulaire est valide !"
  ],
  playerCrit: [
    "CRITIQUE ! Le directeur lui-meme est descendu !",
    "COUP FATAL ! Ton dossier est passe en priorite !",
    "DEVASTATEUR ! Le systeme a buge en ta faveur !",
    "LEGENDAIRE ! Le prefet a signe en personne !"
  ],
  bossIntro: [
    "Un nouveau challenger administratif apparait...",
    "Le boss charge son formulaire de combat...",
    "ATTENTION -- Boss administratif detecte !"
  ],
  levelUp: [
    "LEVEL UP ! Tu maitrises de mieux en mieux la paperasse !",
    "NOUVEAU NIVEAU ! Ton aura administrative s'intensifie !",
    "EVOLUTION ! Tu deviens un bureaucrate aguerri !"
  ],
  dodgeMessages: [
    "Esquive ! T'etais pas a l'adresse indiquee !",
    "Manque ! Ton dossier etait au mauvais guichet !",
    "Rate ! Tu etais en rendez-vous... ailleurs !"
  ],
  defenseMessages: [
    "Tu serres les dents dans la file d'attente. +DEF !",
    "Ta patience est indestructible. Bouclier leve !",
    "Tu attends stoiquement. L'administration ne peut rien contre toi."
  ],
  healMessages: [
    "Les larmes coulent. Le guichetier est gene. +HP !",
    "Tu te mouches bruyamment. Tout le monde te regarde. +HP !",
    "Le cafe de la machine te requinque. Presque."
  ]
};
